import React from 'react';
import { aboutContent } from '../../data/mock';

const AboutSection = () => {
  const highlights = [
    { title: 'MDG-First', description: 'SAP MDG as primary specialization' },
    { title: 'Founder-Led', description: 'Direct senior engagement' },
    { title: 'Consulting Delivery', description: 'No software products' },
    { title: 'Supporting Services', description: 'SAP, software, AI, DevOps' },
    { title: 'Enterprise Focus', description: 'Audit and compliance ready' }
  ];

  return (
    <section id="about" className="relative py-24 overflow-hidden">
      {/* Background with subtle data image */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1F33] via-[#0F2942] to-[#0B1F33]"></div>
      
      {/* Subtle background image - Network pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <img 
          src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=2834&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#1F7A8C]/5 to-transparent pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#1F7A8C]/10 rounded-full blur-[150px] pointer-events-none"></div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-0.5 bg-[#5BB5C5] rounded"></div>
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-widest">About Us</p>
        </div>
        <h2 className="text-[#5BB5C5] font-semibold text-2xl lg:text-3xl mb-8 max-w-2xl">
          {aboutContent.headline}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-5">
            <p className="text-[#9AACBC] text-lg leading-relaxed">
              <span className="text-[#E8B86D]">IJSS IT Solutions Pvt. Ltd.</span> is a <span className="text-[#5BB5C5]">SAP Master Data Governance</span>-first consulting company. <span className="text-[#5BB5C5]">SAP MDG</span> is our primary and dominant specialization across all engagements.
            </p>
            
            <p className="text-[#8899AA] leading-relaxed">
              Unlike generalist SAP consultancies, <span className="text-[#E8B86D]">IJSS IT Solutions</span> has chosen to lead with <span className="text-[#5BB5C5]">SAP Master Data Governance</span>. This MDG-first positioning enables deep technical proficiency, consistent delivery quality, and the ability to address complex governance challenges requiring focused expertise.
            </p>

            <p className="text-[#8899AA] leading-relaxed">
              The company also delivers select <span className="text-[#5BB5C5]">SAP services</span>, software engineering, automation, analytics, and cloud capabilities. These supporting services are deployed only when they strengthen, extend, or operationalize <span className="text-[#5BB5C5]">MDG-led</span> and <span className="text-[#5BB5C5]">SAP S/4HANA</span> transformation programs.
            </p>

            <p className="text-[#8899AA] leading-relaxed">
              Our team brings over <span className="text-[#E8B86D]">15 years</span> of combined <span className="text-[#5BB5C5]">SAP MDG</span> experience, having successfully delivered projects for global enterprises including pharmaceutical companies, manufacturing conglomerates, government entities, and <span className="text-[#E8B86D]">Fortune 500</span> organizations.
            </p>

            <p className="text-[#8899AA] leading-relaxed">
              <span className="text-[#E8B86D]">IJSS IT Solutions</span> operates with a founder-led model where senior consultants maintain direct engagement accountability. The <span className="text-[#5BB5C5]">MASTERDATA NOW™</span> framework provides a structured methodology for all MDG engagements.
            </p>
          </div>

          {/* Highlights Sidebar */}
          <div className="space-y-3">
            <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-wider mb-4">
              Our Approach
            </p>
            {highlights.map((item, index) => (
              <div key={index} className="service-card-secondary p-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#5BB5C5] rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h4 className="text-[#5BB5C5] font-medium text-sm mb-1">{item.title}</h4>
                    <p className="text-[#8899AA] text-xs">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
